import React, { Fragment, useState } from "react";
import { Grid2 as Grid } from "@mui/material";
import { DesktopDatePickerField, FormAutoComplete, FormTextField } from "../../../components/generic/GenericTextFields";
import { GENDER, PROFESSIONS, VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import { COUNTRIES } from "../../../enums/countries";
import { object, string } from "yup";
import { useFormik } from "formik";
import useNotiStack from "../../../hooks/useNotiStack";
import { createOrUpdateUserDetails } from "../../../config/apisauce";
import { EditProfileButtons } from "./EditProfileButtons";
import { birthdayValidation } from "../../../helpers/genericFormValidations";

export const EditBasicInfoForm = ({ creatorDetails, refetchDetails, handleClose, refetchCreatorList }) => {
  const { success } = useNotiStack();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    const params = {
      ...values,
      user_id: creatorDetails?.user_id,
      current_step: VERIFY_FACE_ID_KEY
    };
    const { ok } = await createOrUpdateUserDetails(params);
    if (ok) {
      success('Successfully updated basic information!');
      refetchDetails();
      refetchCreatorList();
      handleClose();
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      name: creatorDetails?.user?.name ?? "",
      profession: creatorDetails?.profession ?? "",
      gender: creatorDetails?.gender ?? "",
      country: creatorDetails?.country ?? "",
      birthday: creatorDetails?.birthday ?? ""
    },
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({
      ...birthdayValidation,
      'name': string().trim().required('Creator name is required'),
      'profession': string().trim().required('Profession is required'),
      'gender': string().trim().required('Gender is required'),
      'country': string().trim().required('Country is required')
    }),
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <FormTextField
            value={formik?.values.name}
            placeholder={'Name'}
            label={'Creator Name'}
            error={Boolean(formik?.errors?.name)}
            helperText={formik?.errors?.name}
            handleChange={(value) => formik.setFieldValue('name', value)}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <FormAutoComplete
            value={formik?.values.profession}
            options={PROFESSIONS}
            label={'Profession'}
            placeholder={'Please Select'}
            error={Boolean(formik?.errors?.profession)}
            helperText={formik?.errors?.profession}
            handleChange={(value) => formik.setFieldValue('profession', value)}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <DesktopDatePickerField
            value={formik?.values?.birthday}
            label={'Birthday'}
            error={Boolean(formik?.errors?.birthday)}
            helperText={formik?.errors?.birthday}
            handleChange={(value) => formik.setFieldValue('birthday', value)}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <FormAutoComplete
            value={formik?.values.gender}
            options={GENDER}
            label={'Gender'}
            placeholder={'Please Select'}
            error={Boolean(formik?.errors?.gender)}
            helperText={formik?.errors?.gender}
            handleChange={(value) => formik.setFieldValue('gender', value)}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <FormAutoComplete
            value={formik?.values.country}
            options={COUNTRIES}
            label={'Country'}
            placeholder={'Please Select'}
            error={Boolean(formik?.errors?.country)}
            helperText={formik?.errors?.country}
            handleChange={(value) => formik.setFieldValue('country', value)}
          />
        </Grid>
      </Grid >
      <EditProfileButtons
        handCancel={() => handleClose()}
        handleSubmit={() => formik.handleSubmit()}
        loading={loading}
      />
    </Fragment>
  );
};